// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NTfJB","badges":"styles_badges__UPtm3"};